import type { AutorNaTela } from '../../types/repositorios'

/**
 * A ordem da lista de autores: quem está no relatório primeiro, a equipe interna por último —
 * ela está fora de todas as contas, e a lista começa por quem está dentro. Dentro de cada grupo,
 * quem mais fez commit vem antes.
 */
export function ordenarAutores(autores: AutorNaTela[]): AutorNaTela[] {
  return [...autores].sort((a, b) => Number(a.equipeInterna) - Number(b.equipeInterna) || b.commits - a.commits)
}
